import { PROFILE_BIRTH_DATE_SEPARATOR } from '@/constants/profile';
import { applyBirthDateInput, completeBirthDateYear } from '@/helpers/profile-birth-date';

export const useProfileBirthDateField = (value, onTouched) => {
  const replaceValue = (input, nextValue, caret) => {
    input.value = nextValue;
    value.value = nextValue;
    input.setSelectionRange(caret, caret);
  };

  const removeDigitBeforeSeparator = (input, caret) => {
    const next = applyBirthDateInput(input.value.slice(0, caret - 2) + input.value.slice(caret - 1), caret - 2);

    replaceValue(input, next.value, next.caret);
  };

  const handleInput = (event) => {
    const input = event.target;
    const next = applyBirthDateInput(input.value, input.selectionStart ?? input.value.length);

    replaceValue(input, next.value, next.caret);
  };

  const handleKeydown = (event) => {
    const input = event.target;
    const caret = input.selectionStart ?? 0;
    if (caret !== input.selectionEnd) return;

    const isSeparatorBefore = input.value[caret - 1] === PROFILE_BIRTH_DATE_SEPARATOR;
    const isSeparatorAfter = input.value[caret] === PROFILE_BIRTH_DATE_SEPARATOR;

    if (event.key === 'Backspace' && isSeparatorBefore) {
      event.preventDefault();
      removeDigitBeforeSeparator(input, caret);
      return;
    }

    if (event.key === 'ArrowLeft' && isSeparatorBefore) {
      event.preventDefault();
      input.setSelectionRange(caret - 2, caret - 2);
      return;
    }

    if (event.key === 'ArrowRight' && isSeparatorAfter) {
      event.preventDefault();
      input.setSelectionRange(caret + 2, caret + 2);
    }
  };

  const handleBlur = (event) => {
    const input = event.target;
    const completed = completeBirthDateYear(input.value);

    if (completed !== input.value) replaceValue(input, completed, completed.length);
    onTouched();
  };

  return { handleInput, handleKeydown, handleBlur };
};
